import * as React from 'react';
import {
  DesignerLogo,
  ExplorerLogo,
  StudioLogo,
} from 'vet-bones/design-system/components';

import { ProductCard } from 'src/ui/components/ProductCard';
import { copy } from 'src/ui/templates/copy';

type StardogAppsProps = {
  currentIndex: number | null;
  goToExplorer: (index?: number) => void;
  goToDesigner: (index?: number) => void;
  goToStudio: (index?: number) => void;
};

/* istanbul ignore next */
export const StardogApps: React.FC<StardogAppsProps> = ({
  currentIndex,
  goToExplorer,
  goToDesigner,
  goToStudio,
}: StardogAppsProps) => (
  <div className="dashboard-cards">
    <div className="dashboard-apps">
      <ProductCard
        description={copy.dashboard.designer.description}
        icon={DesignerLogo}
        label={copy.dashboard.designer.label}
        onClick={() => goToDesigner(currentIndex || undefined)}
      />
      <ProductCard
        description={copy.dashboard.explorer.description}
        icon={ExplorerLogo}
        label={copy.dashboard.explorer.label}
        onClick={() => goToExplorer(currentIndex || undefined)}
      />
      <ProductCard
        description={copy.dashboard.studio.description}
        icon={StudioLogo}
        label={copy.dashboard.studio.label}
        onClick={() => goToStudio(currentIndex || undefined)}
      />
    </div>
  </div>
);
